/**
 * =============================================================================
 *  BFCM 2026 — FREE 10 mL TRAVEL SPRAY SYNC + CHECKOUT LOCK  (theme "BFCM 2026 — Claude draft")
 *
 *  Replaces the business-as-usual volume-deal widget (3 for $198 / 5 for $297).
 *  Pricing comes entirely from Shopify ($60 bottles + automatic bundle discounts); the cart
 *  drawer and band are rendered in Liquid.
 *
 *  1. Free spray sync: keeps exactly one free spray per sale perfume in the cart, using
 *     /cart?view=gkbfcm, then asks the drawer / cart page to re-render (cart:refresh).
 *  2. Labels the spray line on the cart page ("3 × Free 10 mL Travel Spray").
 *  3. North / South Island shipping-estimate chips in the cart drawer (display only).
 *  4. CHECKOUT LOCK until Tue 10 Nov 2026, 7:00pm NZDT (LAUNCH below): every checkout button
 *     shows a countdown and is disabled, checkout submits and /checkout links are blocked,
 *     express buttons are hidden (CSS on html.gk-locked). Unlocks by itself at LAUNCH.
 *     To change the launch time, edit LAUNCH here AND the inline script in
 *     snippets/header-secondary-area.liquid.
 * =============================================================================
 */
(function (win, doc) {
  'use strict';

  var SPRAY_ID = 68362004627707;
  var SPRAY_HANDLE = 'free-10ml-travel-spray';
  var STATE_URL = '/cart?view=gkbfcm';
  var MAX_FAILURES = 3;
  var SHIP_KEY = 'gk_ship_island';
  var LAUNCH = Date.UTC(2026, 10, 10, 6, 0, 0); /* Tue 10 Nov 2026, 7:00pm NZDT */

  if (win.__gkBfcmSpray) return;
  win.__gkBfcmSpray = true;

  var origFetch = win.fetch ? win.fetch.bind(win) : null;
  if (!origFetch) return;

  /* ------------------------------------------------------------------ */
  /* 4. Checkout lock                                                     */
  /* ------------------------------------------------------------------ */
  function isLocked() { return Date.now() < LAUNCH; }

  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function countdown(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    return (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
  }

  var lockTimer = null;
  function applyLock() {
    var locked = isLocked();
    doc.documentElement.classList.toggle('gk-locked', locked);
    var btns = doc.querySelectorAll('.checkout-button, button[name="checkout"]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (locked) {
        if (!btn.hasAttribute('data-gk-orig')) btn.setAttribute('data-gk-orig', btn.innerHTML);
        if (!btn.disabled) btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        var span = btn.querySelector('.gk-lock-label');
        if (!span) {
          btn.innerHTML = '<span class="gk-lock-label"></span>';
          span = btn.querySelector('.gk-lock-label');
        }
        var label = 'Checkout opens in ' + countdown(LAUNCH - Date.now());
        if (span.textContent !== label) span.textContent = label;
        var next = btn.nextElementSibling;
        if (!(next && next.classList && next.classList.contains('gk-lock-note'))) {
          var note = doc.createElement('div');
          note.className = 'gk-lock-note';
          note.textContent = 'Black Friday opens Tue 10 Nov at 7pm. Build your cart now and it’ll be ready to go.';
          btn.insertAdjacentElement('afterend', note);
        }
      } else if (btn.hasAttribute('data-gk-orig')) {
        btn.innerHTML = btn.getAttribute('data-gk-orig');
        btn.removeAttribute('data-gk-orig');
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        var n2 = btn.nextElementSibling;
        if (n2 && n2.classList && n2.classList.contains('gk-lock-note')) n2.parentNode.removeChild(n2);
      }
    }
    if (!locked && lockTimer) {
      clearInterval(lockTimer);
      lockTimer = null;
      /* Launch moment: re-render carts so they show the live buttons. */
      doc.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }

  /* Block checkout before launch, even if a button slips through. */
  doc.addEventListener('submit', function (e) {
    if (!isLocked()) return;
    var sub = e.submitter;
    var form = e.target;
    var isCheckout = (sub && sub.name === 'checkout') ||
      (form && form.getAttribute && /\/checkout/.test(form.getAttribute('action') || ''));
    if (isCheckout) { e.preventDefault(); e.stopImmediatePropagation(); applyLock(); }
  }, true);
  doc.addEventListener('click', function (e) {
    if (!isLocked() || !e.target || !e.target.closest) return;
    var el = e.target.closest('.checkout-button, button[name="checkout"], a[href*="/checkout"]');
    if (el) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  /* ------------------------------------------------------------------ */
  /* 1. Free spray sync                                                   */
  /* ------------------------------------------------------------------ */
  var timer = null;
  var running = false;
  var rerun = false;
  var failures = 0;

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(sync, typeof delay === 'number' ? delay : 350);
  }
  function onCartAction(delay) {
    failures = 0;
    schedule(delay);
  }
  function postJSON(url, payload) {
    return origFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('spray update failed (' + r.status + ')');
      return r.json();
    });
  }
  function sync() {
    if (failures >= MAX_FAILURES) return;
    if (running) { rerun = true; return; }
    running = true;
    origFetch(STATE_URL + '&_=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error('state ' + r.status);
        return r.text();
      })
      .then(function (text) {
        var s = JSON.parse(text.trim());
        var want = Math.max(0, parseInt(s.bottles, 10) || 0);
        var have = Math.max(0, parseInt(s.sprays, 10) || 0);
        if (want === have) return false;
        if (have === 0) {
          return postJSON('/cart/add.js', { items: [{ id: SPRAY_ID, quantity: want }] }).then(function () { return true; });
        }
        var updates = {};
        updates[SPRAY_ID] = want;
        return postJSON('/cart/update.js', { updates: updates }).then(function () { return true; });
      })
      .then(function (changed) {
        failures = 0;
        if (changed) {
          doc.dispatchEvent(new CustomEvent('cart:refresh'));
          rerun = true;
        }
      })
      .catch(function (err) {
        failures++;
        if (win.console) console.warn('[GK BFCM] travel spray sync:', err);
        if (failures < MAX_FAILURES) rerun = true;
      })
      .then(function () {
        running = false;
        if (rerun) { rerun = false; schedule(800); }
      });
  }

  /* 2. Label the spray line(s) on the cart page with the quantity. */
  function labelSprays() {
    var links = doc.querySelectorAll('a.cart-product-link[href*="/products/' + SPRAY_HANDLE + '"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var row = a.closest('.product-cart-item, tr');
      if (!row) continue;
      var input = row.querySelector('input.qty');
      var n = input ? parseInt(input.value, 10) || 0 : 0;
      var label = (n > 0 ? n + ' × ' : '') + 'Free 10 mL Travel Spray';
      if (a.textContent !== label) a.textContent = label;
    }
  }

  /* 3. Shipping estimate chips (cart drawer). */
  function getIsland() {
    try { return win.sessionStorage.getItem(SHIP_KEY) === 'si' ? 'si' : 'ni'; } catch (e) { return 'ni'; }
  }
  function applyIsland(island) {
    var drawer = doc.getElementById('Cart-Drawer');
    if (drawer) drawer.classList.toggle('gk-ship-si', island === 'si');
  }
  doc.addEventListener('click', function (e) {
    var chip = e.target && e.target.closest ? e.target.closest('[data-gk-ship]') : null;
    if (!chip) return;
    e.preventDefault();
    var island = chip.getAttribute('data-gk-ship') === 'si' ? 'si' : 'ni';
    try { win.sessionStorage.setItem(SHIP_KEY, island); } catch (err) {}
    applyIsland(island);
  });

  /* Re-apply labels and the lock after any re-render (drawer, cart page). */
  var domQueued = false;
  function onDomChange() {
    if (domQueued) return;
    domQueued = true;
    (win.requestAnimationFrame || setTimeout)(function () {
      domQueued = false;
      labelSprays();
      applyLock();
    });
  }

  /* Watch every cart mutation the theme (or an app) makes with fetch. */
  win.fetch = function (input, init) {
    var p = origFetch(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        p.then(function () { onCartAction(); }, function () {});
      }
    } catch (e) {}
    return p;
  };

  doc.addEventListener('cart:item-added', function () { onCartAction(); });
  doc.addEventListener('line-item:change:end', function () { onCartAction(); });
  win.addEventListener('pageshow', function (e) { if (e.persisted) { onCartAction(200); applyLock(); } });

  function start() {
    applyIsland(getIsland());
    applyLock();
    if (isLocked()) lockTimer = setInterval(applyLock, 1000);
    schedule(400);
    labelSprays();
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(onDomChange).observe(doc.body, { childList: true, subtree: true });
    }
  }
  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}(window, document));
